import React from "react";

export default function PlayCircle(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.134" height="13.134">
			<path d="m5.254 9.522 3.94-2.955-3.94-2.955ZM6.567 0a6.567 6.567 0 1 0 6.567 6.567A6.569 6.569 0 0 0 6.567 0Zm0 11.82a5.254 5.254 0 1 1 5.253-5.253 5.26 5.26 0 0 1-5.253 5.253Z" />
		</svg>
	);
}
